// Labeled by kind (AI or conventional), not by the catalog's implementation names.
export const PROPAGATION_MODELS = [
    { name: 'reg_td_cc_al', labelId: 'replanning.propagate.aiDeformable' },
    { name: 'reg_ad_cc_al', labelId: 'replanning.propagate.deformable' },
    { name: 'reg_ar_cc_al', labelId: 'replanning.propagate.rigid' },
];

export function propagationModelLabelId(name?: string): string | undefined {
    return PROPAGATION_MODELS.find((model) => model.name === name)?.labelId;
}
